export default "__VITE_ASSET__BaavoQfh__"